<template>
  <content-loader
    view-box="0 0 330 350"
    :speed="2"
    primary-color="#f3f3f3"
    secondary-color="#ecebeb"
    width="250"
    height="350"
  >
    <rect x="8" y="44" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="71" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="97" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="123" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="150" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="216" rx="0" ry="0" width="70" height="22" /> 
    <rect x="91" y="216" rx="0" ry="0" width="70" height="22" /> 
    <rect x="8" y="177" rx="3" ry="3" width="220" height="20" /> 
    <rect x="8" y="17" rx="3" ry="3" width="220" height="20" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
    name: "SideBarWithInputFormLoader",
    components: {
        ContentLoader, 
    }
};
</script>
